// import Vue from 'vue'
import axios from 'axios'
// import store from '@/store'
// import notification from 'ant-design-vue/es/notification'
import { VueAxios } from './axios'

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // api base_url
  timeout: 60000 // 请求超时时间
})

const err = (error) => {
  // window.location.href = '/'
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
  const { headers, url } = config
  const token = sessionStorage.getItem('authorization')
  const decoderToken = decodeURIComponent(token)
  const obj = { Authorization: decoderToken }
  const newUrl = `https://api.ixiaosa.com${url}`
  const newHeaders = { ...headers, ...obj }
  return { ...config, ...{ headers: newHeaders, url: newUrl } }
}, err)

// response interceptor
service.interceptors.response.use((response) => {
  return response.data
}, err)

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}



// WEBPACK FOOTER //
// ./src/utils/request.js